import angular from 'angular';

import CartsReportView from './carts-report-view';
import EventsTable from './events-table';

const module = angular
    .module('app.reports', [])
    .component(CartsReportView.selector, CartsReportView)
    .component(EventsTable.selector, EventsTable)
    ;

export default module.name;



// WEBPACK FOOTER //
// ./src/app/reports/index.js